// Adapted from https://github.com/born2net/Angular-kitchen-sink/blob/65b01608a769578a94850bc39254d7e81f82d239/src/pipes/OrderBy.ts
import {Pipe, PipeTransform} from '@angular/core';
import * as _ from 'lodash';

@Pipe({
    name: 'orderBy'
})
export class OrderByPipe implements PipeTransform {
  transform(input: Object[], ...args: any[]): Object[] {
    let field: string =  args[0];
    const desc = args[1] === undefined ? false : args[1];

    if (input && field) {
      return Array.from(input).sort((a: Object, b: Object) => {
        if (_.get(a, field) < _.get(b, field)) {
          return desc ? 1 : -1;
        }
        if (_.get(a, field) > _.get(b, field)) {
          return desc ? -1 : 1;
        }

        return 0;
      });
    }
    return input;
  }
}



// WEBPACK FOOTER //
// ../node_modules/angular2-template-loader!./ng2/shared/pipes/order-by.pipe.ts